import React from 'react'
import bf1 from '../im/before-footer/before-footer-img1.png'
import bf2 from '../im/before-footer/before-footer-img2.png'
import bf3 from '../im/before-footer/before-footer-img3.png'
import bf4 from '../im/before-footer/before-footer-img4.png'
import bf5 from '../im/before-footer/before-footer-img5.png'
import bf6 from '../im/before-footer/before-footer-img6.png'
import bf7 from '../im/before-footer/before-footer-img7.png'
import bf8 from '../im/before-footer/before-footer-img8.png'
import cl from "../im/cl.png"

function Footerr() {
    return (
        <div>

            <div className='row no-gutters'>




                <div className='col ' >
                    <img src={bf1} className='d-inline-block col-1'></img>
                    <img src={bf2} className='d-inline-block  col-1'></img>
                    <img src={bf3} className='d-inline-block w-30 col-1'></img>
                    <img src={bf4} className='d-inline-block w-30 col-1'></img>
                    <img src={bf5} className='d-inline-block w-30 col-1'></img>
                    <img src={bf6} className='d-inline-block w-30 col-1'></img>
                    <img src={bf1} className='d-inline-block col-1'></img>
                    <img src={bf2} className='d-inline-block  col-1'></img>
                    <img src={bf3} className='d-inline-block w-30 col-1'></img>
                    <img src={bf4} className='d-inline-block w-30 col-1'></img>
                    <img src={bf5} className='d-inline-block w-30 col-1'></img>
                    <img src={bf6} className='d-inline-block w-30 col-1'></img>




                </div>


                <footer className='text-light'>

                    <section>
                        <div className=' mt-5'>
                            <div className='row'>
                                <div className='col-lg-5 col-sm-12 bg-'>
                                    <div>

                                        <h6 class="text-uppercase fw-bold ">
                                            <img src={cl} className=' '></img>  hostwire systems
                                        </h6>

                                        <h6 className='mx-4'>We are a huge marketplace dedicated to connecting great artists of all mediums with their fans and unique token collectors!</h6>

                                        <div className=' mx-4'>
                                            <h6 className='my-5'><a href="" class="me-4  ">
                                                <i class="fab fa-facebook-f"></i>
                                            </a>
                                                <a href="" class="me-4 ">
                                                    <i class="fab fa-twitter"></i>
                                                </a>
                                                <a href="" class="me-4 ">
                                                    <i class="fab fa-google"></i>
                                                </a>
                                                <a href="" class="me-4 t">
                                                    <i class="fab fa-instagram"></i>
                                                </a>
                                                <a href="" class="me-4 ">
                                                    <i class="fab fa-linkedin"></i>
                                                </a>
                                                <a href="" class="me-4 ">
                                                    <i class="fab fa-github"></i>
                                                </a>
                                            </h6>

                                        </div>
                                        <div className='mx-4'>
                                            <form className=''>
                                                <div className='border border-3 border-primary col-lg-8 col-sm-12 rounded-9'>
                                                    <input type="text" placeholder='subscribe to our newsletter' className='col-lg-9 col-sm-10 rounded-9 bgg border-0 p-3 fotfm text-light' />
                                                    <i type="submit" class="fas fa-long-arrow-alt-right "></i>
                                                </div>
                                            </form>
                                        </div>

                                    </div>



                                </div>
                                <div className='col-lg-7 col-sm-12  col-md-12 p-5'>
                                    <div className='row fw-bold'>


                                        <div className='col-lg-5  col-md-4 col-sm-6 '>

                                            <h6 class="text-uppercase fw-bold mt-5">
                                                Cryptoki Market
                                            </h6>
                                            <div className='col-lg-6 d-inline-block  mt-4 '>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Home

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Explore

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 ">
                                                        Creators

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Collectors

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Spotlight

                                                    </a>
                                                </p>
                                            </div>
                                            <div className=' col-lg-6 d-inline-block  '>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Profile Page

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6 ">
                                                        Artwork Page

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Activity

                                                    </a>
                                                </p>

                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Upload Art

                                                    </a>
                                                </p>
                                            </div>




                                        </div>




                                        <div className='col-lg-3 col-md-4 col-sm-6 '>

                                            <h6 class="text-uppercase fw-bold mt-5">
                                                Explore
                                            </h6>
                                            <div className='col d-inline-block mt-4  '>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        3D Artworks

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6 ">
                                                        Motion Graphics

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Illustrations

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6 ">
                                                        Photography
                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4  h6">
                                                        Pop Culture

                                                    </a>
                                                </p>
                                            </div>





                                        </div>


                                        <div className='col-lg-4  col-md-4'>

                                            <h6 class="text-uppercase fw-bold mt-5">
                                                Helpful Links
                                            </h6>
                                            <div className='col d-inline-block  mt-4'>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Our Blog

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        Become a Creator

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        FAQs

                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6">
                                                        About Us
                                                    </a>
                                                </p>
                                                <p>
                                                    <a href="" class="me-4 h6 ">
                                                        Contact

                                                    </a>
                                                </p>
                                            </div>





                                        </div>


                                    </div>




                                </div>

                            </div>
                            <div className='p-3 mt-5'>
                                <hr className=''></hr>


                                <div className='row'>
                                    <div className='col-lg-4 col-md-5 align-self-start'>
                                    <h6>Cryptoki 2021 - All Rights Reserved</h6>

                                    </div>
                                    <div className='col-lg-4  col-md-3 align-seft-end'>
                                   

                                    </div>
                                    <div className='col-lg-4  col-md-4 align-seft-end text-center'>
                                    <h6><a href=''>Terms of Service</a>    <span className=''> <a>Privacy</a></span>
                                       </h6>

                                    </div>

                                </div>

                            </div>



                        </div>
                    </section>





                </footer>

















            </div>


        </div>
    )
}

export default Footerr
